import { FC, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { supplierOperationsAPI } from '../../../../api/supplier/supplierOperationsAPI'
import {
  ServicedArea,
  SupplierOperation,
} from '../../../../api/supplier/supplierOperationsAPI.types'
import { Supplier } from '../../../../api/supplier/suppliers.types'
//API
import { AxiosResponse } from 'axios'
import {
  useSupplierDispatch,
  useSupplierState,
} from '../../../../Pages/Supplier/SupplierContext'

export const withSupplierOperation = (
  WC: FC<{
    supplierId: number
    supplierOperation: SupplierOperation
    isLoadingOperations: boolean
  }>,
) => {
  const SupplierOperationHOC = (props: any) => {
    const supplier: Supplier = useSelector(
      (state: any) => state.suppliers.supplier,
    )
    const { supplierOperation: supplierOperationState } = useSupplierState()
    const dispatch = useSupplierDispatch()

    const { data, isLoading } = useQuery({
      queryKey: ['SupplierOperation', supplier.id],
      queryFn: async () =>
        supplierOperationsAPI.getSupplierOperationsBySupplierId(supplier.id),
      refetchOnWindowFocus: false,
    })

    let supplierOperation: SupplierOperation | undefined
    useEffect(() => {
      if (data && supplierOperationState !== supplierOperation) {
        dispatch({ type: 'setSupplierOperation', payload: supplierOperation })
      }
    }, [data])

    if (data) {
      supplierOperation =
        data?.data.value.length > 0 ? data?.data.value[0] : undefined
      return (
        <WC
          supplierId={supplier.id}
          supplierOperation={supplierOperation}
          {...props}
        />
      )
    }
    return (
      <WC
        supplierId={supplier.id}
        supplierOperation={undefined}
        isLoadingOperations={isLoading}
        {...props}
      />
    )
  }
  return SupplierOperationHOC
}

export const withServicedAreas = (
  WC: FC<{
    supplierId: number
    servicedAreas: AxiosResponse<ServicedAreas> | undefined
    mode: 'create' | 'edit' | 'view'
  }>,
) => {
  const ServicedAreasHOC = (props: any) => {
    const { supplierOperation } = useSupplierState()
    const supplier: Supplier = useSelector(
      (state: any) => state.suppliers.supplier,
    )
    const dispatch = useSupplierDispatch()

    const { data } = useQuery({
      queryKey: ['ServicedAreas', supplierOperation?.id],
      queryFn: async () => {
        if (supplierOperation && supplierOperation.id) {
          return supplierOperationsAPI.getServicedAreasBySupplierOperationsId(
            supplierOperation.id,
          )
        }
        return null
      },
      refetchOnWindowFocus: false,
    })

    let servicedAreas: Array<ServicedArea> | undefined
    useEffect(() => {
      // if (data && servicedAreasState !== supplierOperation) {
      dispatch({ type: 'setServicedAreas', payload: servicedAreas })
      // }
    }, [data])

    if (data) {
      console.log('servicedArea', data)
      servicedAreas = (data as any).length > 0 ? data : undefined
      return (
        <WC supplierId={supplier.id} servicedAreas={servicedAreas} {...props} />
      )
    }

    return <WC supplierId={supplier.id} servicedAreas={[]} {...props} />
  }
  return ServicedAreasHOC
}
